//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';

import calendarMonth from '../../../../../components/datePicker/calendar/calendarMonth';

import BtnToggle from '../../btnToggle/index.vue';

dayjs.extend(localeData);

export default {
  components: {
    BtnToggle,
  },
  extends: calendarMonth,
};
